import TabList from './TabList';
import { TabListProps, TabListValueProps } from './types';

export type { TabListProps, TabListValueProps };
export default TabList;
